export interface OverallThreatData {
  summaryRansomware?: number;
  summaryMaliciousFile?: number;
  summaryMaliciousUrl?: number;
  summaryPhishing?: number;
  summaryBEC?: number;
  summaryTotalItemsScanned?: number;
  summaryRiskAiAnomaly?: number;
  summaryScam?: number;
}

export function computeTotal(data: OverallThreatData | null) {
  return data?.summaryTotalItemsScanned ?? 0;
}

export function computePhishing(data: OverallThreatData | null) {
  return data?.summaryPhishing ?? 0;
}

export function computeBec(data: OverallThreatData | null) {
  return data?.summaryBEC ?? 0;
}

export function computeRansomware(data: OverallThreatData | null) {
  return data?.summaryRansomware ?? 0;
}

export function computeMaliciousFile(data: OverallThreatData | null) {
  return data?.summaryMaliciousFile ?? 0;
}

export function computeMaliciousURL(data: OverallThreatData | null) {
  return data?.summaryMaliciousUrl ?? 0;
}

export function computeRiskAiAnomaly(data: OverallThreatData | null) {
  return data?.summaryRiskAiAnomaly ?? 0;
}

export function computeScam(data: OverallThreatData | null) {
  return data?.summaryScam ?? 0;
}
